module.exports = __webpack_public_path__ + "static/analog-photo-3ffc3d7cc7d2fd18b75bc8a47e6647ce.jpg";